
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import DpDiagram from '@/components/atoms/DpDiagram/index.vue';

@Component({
  name: 'PerformanceDayOfTheWeekPriceDiagram',
  components: {
  },
})
export default class PerformanceDayOfTheWeekPriceDiagram extends DpDiagram {
  @Prop() protected values!: any;

  @Prop() protected currency!: any;

  @Prop({ default: '' }) protected valueUnit!: string;

  @Prop({ default: 0 }) protected yMaximum!: number;

  protected generateChart(d3: any, width: number, height: number) {
    const margin = ({
      top: 15, right: 40, bottom: 20, left: 0,
    });

    return this.createChart({
      d3,
      width,
      height,
      data: this.values,
      margin,
      currency: this.currency,
      valueUnit: this.valueUnit,
      yMaximum: this.yMaximum,
    });
  }

  protected createChart = ({
    d3,
    width,
    height,
    data,
    margin,
    currency,
    valueUnit,
    yMaximum,
  }: any) => {
    const dataMaxValue = d3.max(data, (d: any) => d.value);
    let maxValue: any;
    if (yMaximum) {
      maxValue = yMaximum;
    } else {
      maxValue = (Math.floor(dataMaxValue / 100) + 1) * 100;
    }
    const tickValues: any = [0, Math.round(maxValue / 2), maxValue];

    const x = (d3 as any).scaleBand()
      .domain(d3.range(data.length))
      .range([margin.left, width - margin.right])
      .padding(0.05);
    const y = (d3 as any).scaleLinear()
      .domain([0, maxValue])
      .range([height - margin.bottom, margin.top]);
    const svg: any = (d3 as any).create('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', [0, 0, width, height]);

    const yGridValues: any = [0, height - margin.bottom - margin.top];
    svg.append('g')
      .selectAll('rect')
      .data(yGridValues)
      .join('rect')
      .attr('x', 0)
      .attr('y', (d: any) => height - margin.bottom - d)
      .attr('height', 0.8)
      .attr('width', width - 20)
      .attr('fill', '#F0F0F0');

    svg.append('path')
      .datum(data)
      .attr('fill', 'none')
      .attr('stroke', '#C8CAD0')
      .attr('stroke-width', 1)
      .attr('d', (d3 as any).line()
        .curve(d3.curveLinear)
        .x((d: any, i: any) => x(i) + (x.bandwidth() / 2))
        .y((d: any) => y(d.value)));

    svg.append('g')
      .selectAll('g')
      .data(data)
      // eslint-disable-next-line
      .join(function (group: any) {
        const container = group.append('g');
        container.append('rect')
          .attr('stroke', '#F0F0F0')
          .attr('x', (d: any, i: any) => x(i) + (x.bandwidth() / 2) - 0.4)
          .attr('y', margin.top)
          .attr('height', height - margin.bottom - margin.top)
          .attr('width', 0.8);
        container.append('text')
          .attr('class', 'text')
          .attr('x', (d: any, i: any) => x(i) + (x.bandwidth() / 2))
          .attr('y', (d: any) => y(d.value) - 8)
          .attr('fill', '#283237')
          .style('font-size', '9px')
          .style('font-style', 'normal')
          .style('line-height', '14px')
          .style('font-family', 'IBM Plex Sans')
          .style('font-weight', 400)
          .attr('text-anchor', 'middle')
          .text((d: any) => `${d.value}${valueUnit}`);
        container.append('circle')
          .attr('cx', (d: any, i: any) => x(i) + (x.bandwidth() / 2) + 1)
          .attr('cy', (d: any) => y(d.value))
          .attr('r', 2)
          .attr('fill', '#283237');
        container.append('rect')
          .attr('class', 'hover')
          .attr('x', (d: any, i: any) => x(i) + (x.bandwidth() / 2) - 5)
          .attr('y', (d: any) => -margin.bottom)
          .attr('height', height)
          .attr('fill', '#fff')
          .attr('opacity', 0.01)
          .attr('width', 10);
      });

    svg.selectAll('.hover')
    // eslint-disable-next-line
      .on('mouseenter', function () {
        const parent: any = (d3 as any).select(this.parentNode);
        parent.select('circle')
          .attr('fill', '#4077F6');
        parent.select('text')
          .attr('fill', '#4077F6')
          .style('font-weight', 600)
          .style('font-size', '10px');
      })
      // eslint-disable-next-line
      .on('mouseleave', function () {
        const parent: any = (d3 as any).select(this.parentNode);
        parent.select('circle')
          .attr('fill', '#283237');
        parent.select('text')
          .attr('fill', '#283237')
          .style('font-weight', 400)
          .style('font-size', '9px');
      });

    if (currency) {
      svg
        .append('text')
        .attr('x', width - margin.right + 12)
        .attr('y', height - margin.bottom + 17.5)
        .attr('fill', '#596D79')
        .style('font-size', '10px')
        .style('font-style', 'normal')
        .style('line-height', '16px')
        .style('font-family', 'IBM Plex Sans')
        .style('letter-spacing', '0.05em')
        .text(currency);
    }

    const yAxis = (g: any) => {
      g
        .attr('transform', `translate(${width - margin.right + 10},0)`)
        .call((d3 as any)
          .axisRight(y)
          .tickValues(tickValues)
          .tickSizeInner(20)
          .tickSizeOuter(0));
      g.select('.domain').remove();
      g.selectAll('.tick')
      // eslint-disable-next-line
        .each(function (d: any, i: any) {
          const tick: any = (d3 as any).select(this);
          if (i === 0) {
            tick.style('opacity', 0);
          }
          tick.select('line')
            .attr('stroke-width', 0.5)
            .attr('stroke', '#E5E5E5');
          const text: any = (d3 as any)
            .select(this)
            .select('text');
          text
            .attr('y', 8)
            .attr('x', 0)
            .attr('fill', '#283237')
            .style('font-weight', 400)
            .style('font-size', '9px')
            .style('font-style', 'normal')
            .style('line-height', '24px')
            .style('font-family', 'IBM Plex Sans');
        });
    };

    const xAxis = (g1: any) => {
      g1
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .call((d3 as any)
          .axisBottom(x)
          .tickFormat((i: any) => data[i].name)
          .tickSizeInner(0)
          .tickSizeOuter(0)
          .tickPadding(10));

      g1.selectAll('.domain').remove();
      g1.selectAll('.tick')
      // eslint-disable-next-line
        .each(function (d: any) {
          (d3 as any)
            .select(this)
            .select('text')
            .style('font-size', '10px')
            .style('font-style', 'normal')
            .style('line-height', '16px')
            .style('font-family', 'IBM Plex Sans')
            .style('letter-spacing', '0.05em')
            .attr('fill', '#596D79');
        });
    };

    svg.append('g')
      .call(xAxis);

    svg.append('g')
      .call(yAxis);

    return svg;
  };

  @Watch('values', { immediate: true, deep: true })
  protected valuesChange() {
    if (this.values) {
      this.renderChart();
    }
  }
}
